import { IconName } from '../../shared/components/icon/icon-registry';
import { Skill } from './course.model';
import { ApiTag } from './api.model';

/**
 * The API models a course without a UI "skill" or icon. Derive both here so
 * every screen paints the same course the same way: a tag whose title matches
 * a skill wins; otherwise fall back to a stable hash of the course id.
 */

const SKILLS: readonly Skill[] = [
  'speaking', 'listening', 'reading', 'writing', 'grammar', 'vocabulary',
];

const ICONS: readonly IconName[] = [
  'cup', 'basket', 'notebook', 'cards', 'mail', 'sun', 'speaker', 'book', 'globe', 'pencil',
];

const hash = (value: string): number => {
  let h = 0;
  for (let i = 0; i < value.length; i++) {
    h = (h * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
};

export const courseSkill = (courseId: string, tags?: ApiTag[]): Skill => {
  const tagged = tags
    ?.map((t) => t.title.trim().toLowerCase())
    .find((t): t is Skill => (SKILLS as readonly string[]).includes(t));
  return tagged ?? SKILLS[hash(courseId) % SKILLS.length];
};

export const courseIcon = (courseId: string): IconName => ICONS[hash(courseId) % ICONS.length];

/** Accent per skill, expressed as design tokens rather than raw hex. */
export const SKILL_ACCENT: Partial<Record<Skill, string>> = {
  speaking: 'var(--color-cat-speaking)',
  listening: 'var(--color-cat-listening)',
  reading: 'var(--color-cat-reading)',
  writing: 'var(--color-warm-400)',
  grammar: 'var(--color-cat-grammar)',
  vocabulary: 'var(--color-cat-vocabulary)',
};

export const skillAccent = (skill: Skill): string =>
  SKILL_ACCENT[skill] ?? 'var(--color-ocean-blue)';
